export enum Routes {
  SignIn = '/sign-in',
  Home = '/',

  Models = '/models',
  NewModel = '/models/new',
  ModelDetails = '/models/:id',

  Styles = '/styles',
  NewStyle = '/styles/new',
  StyleDetails = '/styles/:id',

  Events = '/events',
  NewEvent = '/events/new',
  EventDetails = '/events/:id',

  EventDetailsV2 = '/v2-events/:id',
  EventsV2 = '/v2-events',

  Overlays = '/overlays',
  NewOverlay = '/overlays/new',
  OverlayDetails = '/overlays/:id',

  Masks = '/masks',
  NewMask = '/masks/new',
  MaskDetails = '/masks/:id',

  PrivacyPolicy = '/privacy-policy',
  InstancesManager = '/instances',

  Gcrs = '/gcrs',
  NewGcr = '/gcrs/new',
  GcrDetails = '/gcrs/:id',
}
